import { applyMiddleware, createStore, compose } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducers";

//For browser extension redux-devtools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//creating store
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
